/**
 * A POS sale on the shared document paper (A4 / A5 / 80mm) — the register's
 * "print before pay". Thin wrapper, same pattern as the other print pages.
 */
import { POS_SALE_DOC_CONFIG } from './docPrintConfigs.js';
import { DocumentPrintPage } from './DocumentPrintPage.js';

export function PosSalePrintPage(): JSX.Element {
  return <DocumentPrintPage config={POS_SALE_DOC_CONFIG} />;
}
